import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import ReactBootstrapSlider from 'react-bootstrap-slider'
import 'bootstrap-slider/dist/css/bootstrap-slider.min.css'
import { optionPrintPreview } from '../utils'
import {parseHtmlForReact} from './../../helpers'

@observer
export default class PercentageSliderNumericCombo extends Component {

	constructor(props){
		super(props)
        this.handleSliderChange = this.handleSliderChange.bind(this)
        this.totalWillBe = this.totalWillBe.bind(this)
        this.totalOfAllOtherOptions = this.totalOfAllOtherOptions.bind(this)
        this.syncLocalStateWithFormData = this.syncLocalStateWithFormData.bind(this)
	}

    handleSliderChange(e) {
        const {option, updateTotals, questionMax} = this.props
		const value = e.target.value
		if(this.totalWillBe(value) <= questionMax){
			const valueObj = new Object()
			valueObj[option.id] = value
			updateTotals(valueObj)
			return
		}
		const valueObj = new Object()
		valueObj[option.id] = questionMax - this.totalOfAllOtherOptions()
		updateTotals(valueObj)
	}

	totalWillBe(newValue){
		const {option, getTotals} = this.props
		var total = 0
		const data = getTotals()
        for(let thisoptionid in data){
			let optionid = option.id.toString()
			if(optionid !== thisoptionid){
				total += parseInt(data[thisoptionid])
			} else {
				total += parseInt(newValue)
			}
        }
		return total
    }

	totalOfAllOtherOptions(){
		const {option, getTotals} = this.props
		var total = 0
		const data = getTotals()
        for(let thisoptionid in data){
			let optionid = option.id.toString()
			if(optionid !== thisoptionid){
				total += parseInt(data[thisoptionid])
			}
        }
		return total
    }

	syncLocalStateWithFormData(){
		const {question, option, store, getTotals} = this.props
		const questionResponse = store.initializeQuestionResponse(question, store.progress.currentPageId)
		store.addFormResponse(question, getTotals())
    }
    
    getText = () => {
        const { question, option, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        let text = ''
        if (option.langs[langcode]) {
            ({ text } = option.langs[langcode])
        } else if (option.langs[defaultLocale]) {
            ({ text } = option.langs[defaultLocale])
        } else if (option.langs[initialLocale]) {
            ({ text } = option.langs[initialLocale])
        }

        // return option.langs[langcode]
        //     ? option.langs[langcode].text
        //     : option.langs[defaultLocale]
        //         ? option.langs[defaultLocale].text : ''
        return text
    }

	render() {
		const {question, option, store, getTotals, getSummedTotal, format, questionMax} = this.props
        const {form_data, langcode, is_rtl_language} = store
		const dspMobile = store.displayForMobile()
		//const value = form_data.has(question.id) && !isNaN(form_data.get(question.id).data[option.id])? form_data.get(question.id).data[option.id] : 0
		const value = getTotals()[option.id]
		console.log('value: ', value);
        const postFix = format === '%' ? '%' : ''
		const numericTextBox = 
			!dspMobile 
				?
					<div className="numericbox">
						{`${value}${postFix}`}
					</div> 
				: null
		const valueSpan = numericTextBox ? null : <span className="sliderValue">{value}{postFix}</span>
		const sliderCssClass = dspMobile ? "slider mobile" : "slider"
		const textCssClass = dspMobile ? "text mobile" : "text"
		const rbsSlider = <ReactBootstrapSlider
				ref={(slider) => { this.slider = slider}}
				min={0}
				max={questionMax}
				step={1}
				value={parseInt(value)}
				change={this.handleSliderChange}
				slideStop={this.syncLocalStateWithFormData}
			/>
        const textDiv = <div className={textCssClass}>
            {parseHtmlForReact(store.getOptionTitle(option, question))}
            {store.printMode ? optionPrintPreview(option) : null}
        </div>
		const sliderDiv = <div className={sliderCssClass}>
					<span className="sliderControl radius">
						{rbsSlider}
					</span>
					{valueSpan}
                </div>
		const left_item = is_rtl_language ? sliderDiv : textDiv;
		const right_item = is_rtl_language ? textDiv : sliderDiv
		return (
    		<div className="option radius">
                {left_item}
                {numericTextBox}
                {right_item}
    		</div>
    	)
    }
}
